import styled from "styled-components";

export const StyledModal = styled.div.attrs({
  className: "StyledModal",
})`
  ${(props) =>
    !props.show
      ? `display: none`
      : `
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 10;
  position: fixed;
  overflow-y: auto;
`}
`;

export const StyledContentModal = styled.div.attrs({
  className: "StyledContentModal",
})`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 5rem;
  text-align: center;
`;

export const StyledBodyModal = styled.div.attrs({
  className: "StyledBodyModal",
})`
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y))
    rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y))
    scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  vertical-align: bottom;
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow);
  overflow: hidden;
  display: inline-block;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
`;
